import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Blurhash } from 'react-blurhash';

import { formatDistanceToNow } from 'date-fns';


// Components
import { Button } from '@material-ui/core';
import ImgElement from './ImgElement';

const Image_Block = ({ 
    detailPost,
}) => {

    // Window Width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {

        // Add an event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Clean up the event listener on component unmount
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update the window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Determine window size breakpoints
    const isMobile = windowWidth <= 480;
    const isTablet = windowWidth <= 1000;

    // ------ Set post Image ----------

    let imageContent = (<></>);

    if(detailPost) {
        imageContent = (
            <div onClick={isTablet ? () => window.location = `/post/${detailPost._id}` : null} key={detailPost._id} className='product_media_image_container'>
                <ImgElement img_obj={detailPost} />

                {!isTablet ? (
                    /* Overlay */
                    <div className="media_image_overlay">
                        <div className="media_overlay_container top" onClick={() => window.location = `/post/${detailPost._id}`}>
                            <p>{formatDistanceToNow(detailPost.date)} ago</p>
                        </div>
                    </div>
                ) : (
                    /* Overlay */
                    <div className="media_image_overlay">
                    </div>
                )}
            </div>
        )
    }

    // ------ End: Set post Image ----------
    

    return (
        <Fragment>

            {imageContent}

        </Fragment>
    )
}


Image_Block.propTypes = {

}

// Map these states from Redux store to the component props
const mapStateToProps = state => ({

})

// Connect the Image_Block component to the Redux store and export it
export default connect(mapStateToProps, null)(Image_Block);

